import React, { useState } from 'react';
import { X, Plus } from 'lucide-react';
import { MessageModal } from './MessageModal';
interface AddLeadModalProps {
  isOpen: boolean;
  onClose: () => void;
}
export function AddLeadModal({
  isOpen,
  onClose
}: AddLeadModalProps) {
  const [leadData, setLeadData] = useState({
    name: '',
    email: '',
    phone: '',
    project: '',
    source: '',
    budget: '',
    notes: ''
  });
  const [isMessageModalOpen, setIsMessageModalOpen] = useState(false);
  if (!isOpen) return null;
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!leadData.name || !leadData.phone || !leadData.project) {
      alert('Please fill all required fields');
      return;
    }
    setIsMessageModalOpen(true);
    setTimeout(() => {
      onClose();
      setLeadData({
        name: '',
        email: '',
        phone: '',
        project: '',
        source: '',
        budget: '',
        notes: ''
      });
    }, 2000);
  };
  return <>
      <div data-testid="add-lead-modal-overlay" className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4" data-id="element-308">
        <div data-testid="add-lead-modal" className="bg-white border border-gray-300 max-w-2xl w-full shadow-lg max-h-[90vh] overflow-y-auto" data-id="element-309">
          <div className="flex justify-between items-center p-4 border-b border-gray-200 sticky top-0 bg-white" data-id="element-310">
            <h3 data-testid="add-lead-modal-title" className="font-bold text-lg flex items-center gap-2" data-id="element-311">
              <Plus className="w-5 h-5" data-id="element-312" />
              Add New Lead
            </h3>
            <button data-testid="add-lead-modal-close-btn" onClick={onClose} className="text-gray-400 hover:text-gray-600" data-id="element-313">
              <X className="w-5 h-5" data-id="element-314" />
            </button>
          </div>

          <form data-testid="add-lead-form" onSubmit={handleSubmit} className="p-6 space-y-6" data-id="element-315">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-316">
              <div data-id="element-317">
                <label className="block text-sm font-bold text-gray-700 mb-1" data-id="element-318">
                  Full Name *
                </label>
                <input data-testid="add-lead-name-input" type="text" required value={leadData.name} onChange={e => setLeadData({
                ...leadData,
                name: e.target.value
              })} placeholder="e.g., Rohan Gupta" className="w-full p-2 border border-gray-300 bg-gray-50 focus:outline-none focus:border-gray-500" data-id="element-319" />
              </div>

              <div data-id="element-320">
                <label className="block text-sm font-bold text-gray-700 mb-1" data-id="element-321">
                  Phone Number *
                </label>
                <input data-testid="add-lead-phone-input" type="tel" required value={leadData.phone} onChange={e => setLeadData({
                ...leadData,
                phone: e.target.value
              })} placeholder="e.g., +91 98765 43210" className="w-full p-2 border border-gray-300 bg-gray-50 focus:outline-none focus:border-gray-500" data-id="element-322" />
              </div>
            </div>

            <div data-id="element-323">
              <label className="block text-sm font-bold text-gray-700 mb-1" data-id="element-324">
                Email Address
              </label>
              <input data-testid="add-lead-email-input" type="email" value={leadData.email} onChange={e => setLeadData({
              ...leadData,
              email: e.target.value
            })} placeholder="e.g., rohan@example.com" className="w-full p-2 border border-gray-300 bg-gray-50 focus:outline-none focus:border-gray-500" data-id="element-325" />
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-326">
              <div data-id="element-327">
                <label className="block text-sm font-bold text-gray-700 mb-1" data-id="element-328">
                  Interested Project *
                </label>
                <select data-testid="add-lead-project-select" required value={leadData.project} onChange={e => setLeadData({
                ...leadData,
                project: e.target.value
              })} className="w-full p-2 border border-gray-300 bg-gray-50 focus:outline-none focus:border-gray-500" data-id="element-329">
                  <option value="" data-id="element-330">Select Project</option>
                  <option value="Green Valley Phase 1" data-id="element-331">
                    Green Valley Phase 1
                  </option>
                  <option value="Green Valley Phase 2" data-id="element-332">
                    Green Valley Phase 2
                  </option>
                  <option value="Sunrise Heights" data-id="element-333">Sunrise Heights</option>
                  <option value="Metro Residency" data-id="element-334">Metro Residency</option>
                </select>
              </div>

              <div data-id="element-335">
                <label className="block text-sm font-bold text-gray-700 mb-1" data-id="element-336">
                  Lead Source
                </label>
                <select data-testid="add-lead-source-select" value={leadData.source} onChange={e => setLeadData({
                ...leadData,
                source: e.target.value
              })} className="w-full p-2 border border-gray-300 bg-gray-50 focus:outline-none focus:border-gray-500" data-id="element-337">
                  <option value="" data-id="element-338">Select Source</option>
                  <option value="Website" data-id="element-339">Website</option>
                  <option value="Walk-in" data-id="element-340">Walk-in</option>
                  <option value="Referral" data-id="element-341">Referral</option>
                  <option value="Social Media" data-id="element-342">Social Media</option>
                  <option value="Advertisement" data-id="element-343">Advertisement</option>
                </select>
              </div>
            </div>

            <div data-id="element-344">
              <label className="block text-sm font-bold text-gray-700 mb-1" data-id="element-345">
                Budget Range (Lakhs)
              </label>
              <input data-testid="add-lead-budget-input" type="text" value={leadData.budget} onChange={e => setLeadData({
              ...leadData,
              budget: e.target.value
            })} placeholder="e.g., 40-50" className="w-full p-2 border border-gray-300 bg-gray-50 focus:outline-none focus:border-gray-500" data-id="element-346" />
            </div>

            <div data-id="element-347">
              <label className="block text-sm font-bold text-gray-700 mb-1" data-id="element-348">
                Notes
              </label>
              <textarea data-testid="add-lead-notes-input" value={leadData.notes} onChange={e => setLeadData({
              ...leadData,
              notes: e.target.value
            })} placeholder="Additional information about the lead..." rows={3} className="w-full p-2 border border-gray-300 bg-gray-50 focus:outline-none focus:border-gray-500" data-id="element-349" />
            </div>

            <div className="flex justify-end gap-3 pt-4 border-t border-gray-200" data-id="element-350">
              <button data-testid="add-lead-cancel-btn" type="button" onClick={onClose} className="px-4 py-2 border border-gray-300 text-sm font-bold hover:bg-gray-50" data-id="element-351">
                Cancel
              </button>
              <button data-testid="add-lead-submit-btn" type="submit" className="px-4 py-2 bg-[#1f2933] text-white text-sm font-bold hover:bg-gray-800" data-id="element-352">
                Add Lead
              </button>
            </div>
          </form>
        </div>
      </div>

      <MessageModal isOpen={isMessageModalOpen} onClose={() => setIsMessageModalOpen(false)} title="Lead Added" message={`${leadData.name} has been added to your lead pipeline successfully.`} type="success" data-id="element-353" />
    </>;
}